import { useEffect } from 'react';
import { RNToWebMessage, RNToWebPayloadList } from './webEvents';

export interface EikaMessageEvent<Action extends keyof RNToWebPayloadList> {
    data: string | RNToWebMessage<Action>;
}

const useNativeEventListener = <Action extends keyof RNToWebPayloadList>(
    callback: (event: EikaMessageEvent<Action>) => void
): void => {
    useEffect(() => {
        window?.addEventListener('message', callback); // ios
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        document?.addEventListener('message', callback); // android
        return () => {
            window?.removeEventListener('message', callback); // ios
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            document?.removeEventListener('message', callback); // android
        };
    }, [callback]);
};

const parseJSON = <Action extends keyof RNToWebPayloadList>(data?: string): RNToWebMessage<Action> | undefined => {
    try {
        return JSON.parse(data!) as RNToWebMessage<Action>;
    } catch (e) {
        return undefined;
    }
};

export const parseCallback = <Action extends keyof RNToWebPayloadList>(
    data: string | RNToWebMessage<Action>
): RNToWebMessage<Action> | undefined => {
    if (typeof data === 'string') {
        return parseJSON<Action>(data);
    }
    return data;
};

export default useNativeEventListener;
